<template>
  <div>
    <material-button
      class="d-none"
      data-bs-toggle="modal"
      data-bs-target="#modalAddCategory"
      id="show-modal-add-category"
    ></material-button>
    <div
      class="modal fade"
      id="modalAddCategory"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{ isEditCategory ? 'Edit Category' : 'Add Category' }}</h5>
            <i
              style="cursor: pointer"
              class="material-icons btn-close-modal justify-content-end"
              data-bs-dismiss="modal"
              aria-label="Close"
              >clear</i
            >
          </div>
          <div class="modal-body">
            <div class="w-100" :class="{ 'mb-3': !fieldRequired.isCategoryNameRequire}">
              <label class="fw-bold" for="">Name
                <span class="text-danger">*</span>
              </label>
              <material-input
                v-model="category.name"
                type="text"
                id="category_name"
                name="category_name"
                placeholder="Enter name"
              />
            </div>
            <div class="w-100 mb-3">
              <span
                class="is-invalid"
                v-if="fieldRequired.isCategoryNameRequire"
                >The field is required.</span
              >
            </div>
            <!-- SF292: secondary-language name on the second line of the QR ordering heading. -->
            <div class="w-100 mb-3" v-if="category.type != 2">
              <label class="fw-bold" for="category_name_line_2">Name (line 2)</label>
              <material-input
                v-model="category.name_line_2"
                type="text"
                id="category_name_line_2"
                name="category_name_line_2"
                maxlength="255"
                placeholder="e.g. 季节性菜品"
              />
              <div class="upload-size-hint">
                Secondary language shown on a second line under the category name on QR ordering.
              </div>
            </div>
            <div class="w-100 mb-3">
              <div class="col-lg-12 col-md-12 col-12" style="display: inline-flex;align-items: center;">
                Featured Category
                  <material-checkbox
                   @change="changeFeature(category.is_feature)"
                    v-model="category.is_feature"
                    :checked="category.is_feature"
                    name="sms"
                    class="align-items-center px-3"
                  ></material-checkbox>
                </div>
            </div>
            <!-- POS V2 bill discount: unticked = items of this category are left out of it. -->
            <div class="w-100 mb-3" v-if="category.type != 2">
              <div class="col-lg-12 col-md-12 col-12" style="display: inline-flex;align-items: center;">
                Allow Bill Discount
                  <material-checkbox
                   @change="changeAllowBillDiscount(category.allow_bill_discount)"
                    v-model="category.allow_bill_discount"
                    :checked="category.allow_bill_discount"
                    name="allow_bill_discount"
                    class="align-items-center px-3"
                  ></material-checkbox>
                </div>
            </div>
            <!-- KSK064: icon on the kiosk category tab (replaces the featured star when set). -->
            <div class="w-100 mb-3" v-if="category.type != 2">
              <label class="fw-bold">Kiosk icon</label>
              <KioskIconPicker v-model="category.kiosk_icon" />
            </div>
            <div class="w-100 mb-3">
              <label class="fw-bold" for="">Description</label>
              <material-textarea
                rows="6"
                v-model="category.details"
                id="category_description"
                name="category_description"
                placeholder="Enter description"
              />
            </div>
            <!-- SF291: legend line shown under the category heading on QR ordering. -->
            <div class="w-100 mb-3" v-if="category.type != 2">
              <label class="fw-bold" for="category_legend">Legend</label>
              <div class="legend-row">
                <div class="legend-icon" @click="uploadLegendIcon()">
                  <template v-if="legendIconPreview || category.legend_image">
                    <img :src="legendIconPreview || category.legend_image" alt="" />
                    <i
                      class="fa fa-times legend-icon-remove"
                      aria-hidden="true"
                      @click.stop="clearLegendIcon()"
                    ></i>
                  </template>
                  <i v-else class="material-icons">add_photo_alternate</i>
                </div>
                <material-input
                  class="flex-grow-1"
                  v-model="category.legend"
                  type="text"
                  id="category_legend"
                  name="category_legend"
                  maxlength="255"
                  placeholder="e.g. Tenderness (软嫩度)"
                />
                <input
                  class="d-none"
                  type="file"
                  id="legendIconCategory"
                  accept="image/png,image/jpeg,image/webp"
                  @change="handleLegendIconUpload($event)"
                />
              </div>
              <div class="upload-size-hint">
                Shown under the category name on QR ordering. Icon is optional (square transparent PNG, max 1MB).
              </div>
              <div class="is-invalid" v-if="legendIconError">{{ legendIconError }}</div>
            </div>
            <div class="w-100 mb-3">
              <label class="fw-bold" for=""> Channel type
                <span class="text-danger">*</span>
              </label>
              <Multiselect
                v-model="category.channel_type"
                :options="channelTypes"
                placeholder="Select channel type"
                :canClear="false"
              />
            </div>
            <div class="w-100 mb-3">
              <span
                class="is-invalid"
                v-if="fieldRequired.isChannelTypeRequire"
                >The field is required.</span
              >
            </div>
            <div class="w-100 mb-3">
              <label class="fw-bold" for=""> Order Printer (Kitchen Printing, KDS, Order List)
                <span class="text-danger">*</span>
              </label>
              <Multiselect
                v-model="category.printer_ids"
                mode="tags"
                :close-on-select="true"
                :searchable="true"
                :options="printers"
                placeholder="Select printer"
                :canClear="false"
              />
            </div>
            <div class="w-100 mb-3">
              <span
                class="is-invalid"
                v-if="fieldRequired.isPrinterRequire"
                >The field is required.</span
              >
            </div>
            <div class="w-100 mt-3">
              <div
                class="d-flex align-items-center justify-content-between mb-2"
              >
                <label class="fw-bold mb-0" for>Report Group
                  <span class="text-danger">*</span>
                </label>
                <a
                  @click="gotoTypeAndGroupPage()"
                  class="text-decoration-underline tag-a-custom"
                  >Manage</a
                >
              </div>
              <div class="d-flex">
                <Multiselect
                  v-model="category.type_id"
                  :options="dataTypes"
                  :canClear="false"
                  placeholder="Type"
                  @change="(value) => selectType(value)"
                >
                  <template v-slot:option="{ option }">
                    <!-- Use v-html to render HTML content -->
                    <div v-if="option.value != 'add_new_type'">{{ option.label }}</div>
                    <div v-else v-html="option.html"></div>
                  </template>
                </Multiselect>
                <Multiselect
                  v-model="category.group_id"
                  :options="groups"
                  :canClear="false"
                  class="ms-2"
                  placeholder="Group"
                  :disabled="!category.type_id"
                  @change="(value) => selectGroup(value)"
                >
                  <template v-slot:option="{ option }">
                    <!-- Use v-html to render HTML content -->
                    <div v-if="option.value != 'add_new_group'">{{ option.label }}</div>
                    <div v-else v-html="option.html"></div>
                  </template>
                </Multiselect>
              </div>
            </div>
            <div class="w-100 mb-3">
              <span
                class="is-invalid"
                v-if="fieldRequired.isTypeRequire"
                >The field is required.</span
              >
            </div>
            <div class="w-100 mt-3">
              <label class="fw-bold" for="">Type
                <span class="text-danger">*</span>
              </label>
              <Multiselect
                v-model="category.type"
                :options="types"
                placeholder="Select type"
                :canClear="false"
                :disabled="true"
              />
            </div>
            <!-- <div class="w-100" :class="{ 'mb-3': !fieldRequired.isDefaultPriceRequire}">
              <label class="fw-bold" for="">Default Price
                <span class="text-danger">*</span>
              </label>
              <Multiselect
                v-model="category.price_key_default"
                :options="priceList"
                placeholder="Select price"
                :canClear="false"
              />
            </div>
            <div class="w-100 mb-3">
              <span
                class="is-invalid"
                v-if="fieldRequired.isDefaultPriceRequire"
                >The field is required.</span
              >
            </div> -->
            <div class="w-100 mt-3">
              <label class="fw-bold" for="">Category image</label>
              <div class="dowload-img" v-show="urlImagePreview || category.image">
                <div id="preview" style="position: relative">
                  <img
                    class="image-url"
                    v-if="urlImagePreview || category.image"
                    :src="urlImagePreview || category.image"
                  />
                  <i
                    class="fa fa-times icon-close-sidenav-main danger"
                    v-if="urlImagePreview || category.image"
                    style="
                      position: absolute;
                      color: #f44335;
                      font-size: 20px;
                      right: 5px;
                      top: 8px;
                    "
                    aria-hidden="true"
                    @click="clearImage()"
                  ></i>
                  <div class="btn-edit-img">
                    <i
                      class="fas fa-pencil-alt text-dark"
                      v-if="urlImagePreview || category.image"
                      aria-hidden="true"
                      @click="uploadFile()"
                    ></i>
                  </div>
                </div>
              </div>
              <div
                class="dowload-img"
                @click="uploadFile()"
                v-show="!urlImagePreview && !category.image"
              >
                <material-input
                  style="display: none"
                  type="file"
                  id="imageCategory"
                  @change="handleFileUpload($event)"
                  accept="image/*"
                />
                <i class="material-icons css-icon-upload">backup</i>
                <h6>Click here to upload an image.</h6>
              </div>
              <div class="upload-size-hint">{{ $t('Recommended_Size_Category_Image') }}</div>
              <div
                class="is-invalid d-flex align-items-center pe-2"
                v-if="fieldRequired.isImageRequire"
              >
                {{ messageImageError }}
              </div>
            </div>
            <div
              class="w-100 mt-3"
            >
              <label class="fw-bold" for=""
                >Status
              </label>
              <div class="d-flex">
                <MaterialRadio
                  id="status_1"
                  value="1"
                  class="ps-0"
                  v-model="category.status"
                >
                  Active
                </MaterialRadio>
                <MaterialRadio
                  id="status_2"
                  value="0"
                  v-model="category.status"
                >
                  Inactive
                </MaterialRadio>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="d-flex mt-3">
              <material-button
                v-if="!isEditCategory"
                class="mx-2 btn btn-sm btn-background"
                @click="saveCategory()"
              >
                Add category
              </material-button>
              <material-button
                v-else
                class="mx-2 btn btn-sm btn-background"
                @click="editCategory()"
              >
                Save
              </material-button>
              <material-button
                class="mx-2 btn btn-sm btn-background"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                Cancel
              </material-button>
            </div>
          </div>
          <material-loading :active="loaderActive" />
        </div>
      </div>
    </div>
    <div class="position-fixed top-1 end-1 z-index-9999 message-success">
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import MaterialInput from "@/components/MaterialInput.vue";
import MaterialTextarea from "@/components/MaterialTextarea.vue";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";
import MenusetService from "../services/product/menuset.service";
import Multiselect from "@vueform/multiselect";
import MaterialCheckbox from "@/components/MaterialCheckbox.vue";
import MaterialRadio from "@/components/MaterialRadio.vue";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import ItemService from "../services/product/item.service";
import { scrollToFirstInvalid } from "@/config/utils";
import KioskIconPicker from "@/components/KioskIconPicker.vue";

export default {
  name: "add-category",
  components: {
    KioskIconPicker,
    MaterialInput,
    MaterialTextarea,
    MaterialButton,
    MaterialLoading,
    Multiselect,
    MaterialCheckbox,
    MaterialRadio,
    MaterialSnackbar
  },
  props: {
    keyReload: {
      type: String,
      required: true,
    },
    categoryType: {
      type: Number,
      required: true,
    },
    isEditCategory: {
      type: Boolean,
      default: false
    },
    categoryId: {
      type: Number,
      default: 0
    },
    setId: {
      type: Number,
      default: 0
    },
    isFeature: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      isLoadData: false,
      snackbar: null,
      message: "",
      urlImagePreview: null,
      isErrorUploadImage: false,
      isImageTooSmall: false,
      messageImageError: "",
      fieldRequired: {},
      loaderActive: false,
      legendIconPreview: null,
      legendIconError: "",
      category: {
        id: 0,
        name: "",
        name_line_2: "",
        details: "",
        legend: "",
        legend_image: null,
        channel_type: 1,
        printer_ids: [],
        image: null,
        // price_key_default: '',
        set_id: this.setId,
        type: this.categoryType,
        type_id: 0,
        group_id: 0,
        is_feature: 0,
        kiosk_icon: null,
        allow_bill_discount: 1,
        status: 1
      },
      priceList: [],
      types: [
        {
          value: 1,
          label: "Main"
        },
        {
          value: 2,
          label: "Modifiers"
        }
      ],
      channelTypes: [
        {
          value: 1,
          label: "QR and POS"
        },
        {
          value: 2,
          label: "POS only"
        },
      ],
      printers: [],
      dataTypes: [],
      dataGroupByType: [],
      groups: []
    };
  },
  created() {
    this.getDataFilter();
  },
  methods: {
    uploadFile() {
      $("#imageCategory").click();
    },

    uploadLegendIcon() {
      $("#legendIconCategory").click();
    },

    clearLegendIcon() {
      this.category.legend_image = null;
      this.legendIconPreview = null;
      this.legendIconError = "";
      $("#legendIconCategory").val('');
    },

    handleLegendIconUpload(event) {
      const file = event.target.files[0];
      if (!file) return;
      if (!["image/png", "image/jpeg", "image/webp"].includes(file.type)) {
        this.legendIconError = "Icon must be a PNG, JPG or WEBP image.";
        return;
      }
      if (file.size > 1024 * 1024) {
        this.legendIconError = "Icon size must not exceed 1MB.";
        return;
      }
      this.legendIconError = "";
      this.category.legend_image = file;
      this.legendIconPreview = URL.createObjectURL(file);
    },

    changeFeature(isFeature = 0) {
      if (typeof isFeature == "boolean") {
        this.category.is_feature = isFeature ? 1 : 0;
      }
    },

    changeAllowBillDiscount(allowBillDiscount = 1) {
      if (typeof allowBillDiscount == "boolean") {
        this.category.allow_bill_discount = allowBillDiscount ? 1 : 0;
      }
    },

    clearImage() {
      this.category.image = null;
      this.urlImagePreview = null;
      this.fieldRequired.isImageRequire = false;
      this.isErrorUploadImage = false;
      this.isImageTooSmall = false;
    },

    handleFileUpload(event) {
      this.isImageTooSmall = false;
      let file = event.target.files[0];
      if (file != null || file != undefined) {
        this.category.image = null;
        this.urlImagePreview = null;
        if (
          !["image/png", "image/jpg", "image/jpeg", "image/svg"].includes(
            file.type
          )
        ) {
          this.isErrorUploadImage = false;
          this.fieldRequired.isImageRequire = true;
          this.messageImageError = `File must be an image.`;
        } else {
          const maxFileSize = 1024 * 1024; // 1MB
          if (file.size > maxFileSize) {
            this.fieldRequired.isImageRequire = true;
            this.messageImageError = `File size must not exceed 1MB.`;
            return;
          }

          this.category.image = file;
          this.urlImagePreview = URL.createObjectURL(file);
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = (evt) => {
            let img = new Image();
            img.onload = () => {
              let width = img.width;
              let height = img.height;
              if (width < 100 || height < 100) {
                this.messageImageError = `The image width ${width} x ${height} is too small.`;
                this.fieldRequired.isImageRequire = true;
                this.isErrorUploadImage = true;
                this.isImageTooSmall = true;
              } else {
                this.fieldRequired.isImageRequire = false;
                this.isErrorUploadImage = false;
                this.isImageTooSmall = false;
                this.messageImageError = "";
              }
            };
            img.src = evt.target.result;
          };
        }
      } else {
        this.category.image = null;
        this.urlImagePreview = null;
        this.isErrorUploadImage = false;
        this.messageImageError = "";
      }
    },

    async getDataFilter() {
      this.showLoader();
      var dataForm = {
        get_groups: 1,
        get_printers: 1,
        get_price_list: 1,
      };

      await ItemService.getDataFilter(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            const data = response.data.data;

            this.printers = data.printers;
            this.dataTypes = [...data.types, { value: 'add_new_type', label: '+ Add new type', html: `<a
                class="text-decoration-underline"
                style="color: #007bff;"
                >+ Add New Type</a
              >` }];
            this.dataGroupByType = data.groups;
            this.priceList = data.price_list;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    async getCategoryDetail() {
      if (this.categoryId) {
        this.showLoader();
        await MenusetService.categoryDetail(this.categoryId).then(
          (response) => {
            if (response.data.result.isSuccess) {
              let category = response.data.data;
              this.category = category;
              this.category.name = category.second_name;
              this.selectType(category.type_id);
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.hideLoader();
            this.setTimeOutNotification();
          }
        );
      }
    },

    saveCategory() {
      if (this.processValidate()) {
        this.showLoader();
        MenusetService.createCategory(this.category).then(
          (response) => {
            if (response.data.result.isSuccess) {
              this.category = {
                name: "",
                name_line_2: "",
                details: "",
                legend: "",
                legend_image: null,
                channel_type: 1,
                printer_ids: [],
                image: null,
                set_id: this.setId,
                is_feature: this.isFeature,
                kiosk_icon: null,
                allow_bill_discount: 1,
                type: this.category.type,
                status: 1
              }
              this.urlImagePreview = null;
              this.legendIconPreview = null;
              $("#imageCategory").val('');
              $("#legendIconCategory").val('');
              this.$emit('reload-list-category', 'Add Category Success');
              $(".btn-close-modal").click();
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.hideLoader();
            this.setTimeOutNotification();
          }
        );
      }
    },

    editCategory() {
      if (this.processValidate()) {
        this.showLoader();
        // KSK113 — axios drops null fields from FormData, so "None" never reached the API and the
        // old icon stayed. "" is sent instead; ConvertEmptyStringsToNull stores it as null.
        this.category.kiosk_icon = this.category.kiosk_icon || "";
        MenusetService.updateCategory(this.category).then(
          (response) => {
            if (response.data.result.isSuccess) {
              this.category = {
                name: "",
                name_line_2: "",
                details: "",
                legend: "",
                legend_image: null,
                channel_type: 1,
                printer_ids: [],
                image: null,
                set_id: this.setId,
                is_feature: this.isFeature,
                kiosk_icon: null,
                allow_bill_discount: 1,
                type: this.category.type,
                status: 1
              }
              this.urlImagePreview = null;
              this.legendIconPreview = null;
              $("#imageCategory").val('');
              $("#legendIconCategory").val('');
              this.$emit('reload-list-category', 'Edit Category Success');
              $(".btn-close-modal").click();
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.hideLoader();
            this.setTimeOutNotification();
          }
        );
      }
    },

    selectType(value) {
      if (value === 'add_new_type') {
        // Open ReportGroup route in new tab for adding new type
        this.gotoTypeAndGroupPage();
        this.category.type_id = 0; // Reset type selection
        return;
      }

      if (this.isLoadData) {
        this.category.group_id = 0;
      }

      this.groups = this.dataGroupByType[value] ? [...this.dataGroupByType[value], { value: 'add_new_group', label: '+ Add new group', html: '<a class="text-decoration-underline" style="color: #007bff;">+ Add New Group</a>' }] : [];
    },

    resetRequired() {
      this.fieldRequired.isCategoryNameRequire = false;
      this.fieldRequired.isDefaultPriceRequire = false;
      this.fieldRequired.isPrinterRequire = false;
      this.fieldRequired.isTypeRequire = false;
    },

    processValidate() {
      this.resetRequired();
      var isValid = true;
      if (this.category.name == "" || this.category.name == null) {
        this.fieldRequired.isCategoryNameRequire = true;
        isValid = false;
      }

      if (this.category.channel_type == null || this.category.channel_type == 0) {
        this.fieldRequired.isChannelTypeRequire = true;
        isValid = false;
      }

      if (this.category.printer_ids.length == 0) {
        this.fieldRequired.isPrinterRequire = true;
        isValid = false;
      }

      if (this.category.type_id == 0 || this.category.group_id == 0) {
        this.fieldRequired.isTypeRequire = true;
        isValid = false;
      }

      // if (this.category.price_key_default == "" || this.category.price_key_default == null) {
      //   this.fieldRequired.isDefaultPriceRequire = true;
      //   isValid = false;
      // }

      if (!isValid) {
        scrollToFirstInvalid();
      }

      return isValid;
    },

    clearData() {
      this.resetRequired();
      this.category = {
        id: 0,
        name: "",
        name_line_2: "",
        details: "",
        legend: "",
        legend_image: null,
        channel_type: 1,
        printer_ids: [],
        image: null,
        // price_key_default: '',
        set_id: this.setId,
        is_feature: this.isFeature,
        kiosk_icon: null,
        allow_bill_discount: 1,
        type: this.categoryType,
        type_id: 0,
        group_id: 0,
        status: 1
      };
      this.printers = [];
      this.dataTypes = [];
      this.dataGroupByType = [];
      this.groups = [];
      this.urlImagePreview = null;
      this.legendIconPreview = null;
      this.legendIconError = "";
      $("#legendIconCategory").val('');
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    gotoTypeAndGroupPage() {
      // Open ReportGroup route in new tab
      const routeData = this.$router.resolve({ name: 'ReportGroup' });
      window.open(routeData.href, '_blank');
    },

    selectGroup(value) {
      if (value === 'add_new_group') {
        // Open ReportGroup route in new tab for adding new group
        this.gotoTypeAndGroupPage();
        this.category.group_id = 0; // Reset group selection
        return;
      }
    },
  },
  watch: {
    async keyReload() {
      this.isLoadData = false;
      this.clearData();
      await this.getDataFilter();
      await this.getCategoryDetail();
  
      this.isLoadData = true;
    },
    categoryType(val) {
      this.category.type = val ?? 1; // 1 - Main, 2 - Modifiers
    },
  },
};
</script>
<style scoped>
.legend-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.legend-icon {
  position: relative;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: #f0f2f5;
  border: 1px dashed #c4c9d0;
  border-radius: 6px;
  color: #7b809a;
}

.legend-icon img {
  width: 32px;
  height: 32px;
  object-fit: contain;
}

.legend-icon-remove {
  position: absolute;
  top: -7px;
  right: -7px;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  color: #fff;
  background: #f44335;
  border-radius: 50%;
}

.upload-size-hint {
  margin-top: 6px;
  font-size: 12px;
  font-style: italic;
  color: #6c757d;
}

.modal-body {
  max-height: 75vh;
  overflow-y: auto;
  padding-bottom: 25px;
}

.modal-body .row {
  margin-top: 10px;
}
.content {
  cursor: pointer;
  text-align: center;
  width: 250px;
  height: 250px;
  margin-top: 25px;
  border: 1px solid #ccc;
  margin-left: 10px;
  margin-right: 10px;
  background-color: #f0f2f5;
}
.font-18 {
  font-size: 18px;
}

.dowload-img {
  text-align: center;
  cursor: pointer;
  background-color: #f0f2f5;
  width: 100%;
  height: 300px;
}

.css-icon-upload {
  font-size: 45px !important;
  margin-top: 6rem;
}

.image-url {
  width: 100%;
  height: 300px;
}

.btn-edit-img {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  color: #f44335;
  font-size: 14px;
  right: 30px;
  top: 4px;
  background: #ffffff;
  border-radius: 50%;
}
</style>
